const Select = {
  init() {
    const selects = document.querySelectorAll('select[data-selector="select.field"]');

    if (selects) {
      selects.forEach((select) => {
        new SlimSelect({
          select,
          settings: {
            showSearch: false, // Отключаем input
          },
        });
      });
    }
  }
}

export default Select;